export enum MapView {
  GB_CENSUS = "GbCensus",
  PT_BOUNDARIES = "PtBoundaries",
  ROUTE_LINE = "RouteLine",
  INRIX_VOLUME = "InrixVolume",
  INRIX_AVERAGE_SPEED = "InrixAverageSpeed",
}
